import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';

/** `value` is `showSummaryV2` only — the V1 toggle offers ownership and shares alone. */
export type OwnershipTimelineViewMode = 'ownership' | 'shares' | 'value';

export const ownershipTimelineViewModeJ = atomFamily((_companyId: number) =>
  atom<OwnershipTimelineViewMode>('ownership')
);
